module.exports = __webpack_public_path__ + "static/media/lisa-marie-fernandez-YELLOW-Mira-Flounce-Bonded-Swimsuit_thumb.b0c8d3a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/some-extra- womenswear- product-shots/thumbs/lisa-marie-fernandez-YELLOW-Mira-Flounce-Bonded-Swimsuit_thumb.png
// module id = 328
// module chunks = 0